module.exports = __webpack_public_path__ + "static/media/westinchennai03.307216b5.jpg";